import { render, staticRenderFns } from "./BuildingCounterView.vue?vue&type=template&id=cb2a3492&scoped=true&"
import script from "./BuildingCounterView.vue?vue&type=script&lang=js&"
export * from "./BuildingCounterView.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCounterView.vue?vue&type=style&index=0&id=cb2a3492&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2a3492",
  null
  
)

export default component.exports